import { abyssColors } from '@/theme/colors';
import { ArrowDropDown } from '@mui/icons-material';
import { IconButton, Menu, Stack, Typography } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { MenuStyles } from './shared/styles';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';

type Props = {
  structureName?: string;
  handleToggle: () => void;
  showVersion: boolean;
};

export const StructureMenu = ({ structureName, showVersion, handleToggle }: Props) => {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorElement);
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElement(null);
  };
  const handleItemClick = () => {
    handleToggle();
    handleClose();
  };

  return (
    <div>
      <Stack direction="row" gap={1} alignItems="center" onClick={handleClick}>
        <Typography
          fontWeight={700}
          color={abyssColors.primary[500]}
          fontSize="2.4rem"
          lineHeight="normal"
          onClick={(event) => event.stopPropagation()}
        >
          {structureName}
        </Typography>
        <IconButton sx={{ p: 0 }}>
          <ArrowDropDown sx={{ color: abyssColors.primary[500] }} />
        </IconButton>
      </Stack>
      <Menu
        anchorEl={anchorElement}
        open={open}
        onClose={handleClose}
        sx={MenuStyles}
        elevation={0}
      >
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          padding={1}
          sx={{ cursor: 'pointer', '&:hover': { background: abyssColors.neutral[100] } }}
          onClick={handleItemClick}
        >
          <AbyssIcon iconName="versions" style={{ width: '1.8rem', height: '1.8rem' }} />
          <Typography fontSize="1.2rem" fontWeight={500} color={abyssColors.primary[500]}>
            {showVersion ? 'Show comments' : 'Show version history'}
          </Typography>
        </Stack>
      </Menu>
    </div>
  );
};
